import axios, { API_BASE, handler } from './http-service';

const baseURL = `${API_BASE}/templates`;

export const fetch = async () => {
  return handler(() => axios.get(baseURL));
}

export const findById = async (id: string) => {
  const url = `${baseURL}/${id}`;
  return handler(() => axios.get(url));
}

export const create = async (data: any) => {
  return handler(() => axios.post(baseURL, data));
}

export const update = async (id: string, data: any) => {
  const url = `${baseURL}/${id}`;
  return handler(() => axios.put(url, data));
}

export const remove = async (id: string) => {
  const url = `${baseURL}/${id}`;
  return handler(() => axios.delete(url));
}

const templateService = {
  fetch,
  findById,
  create,
  update,
  remove
};

export default templateService;
